export default "__VITE_ASSET__DDy1w_$H__"